'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

const CompanyResumes = dynamic(() =>
  import('./resumes-company').then(module => module.CompanyResumes),
);

export function Resumes() {
  const isInitialized = useCustomerStore(state => state.isInitialized);
  const customerType = useCustomerStore(state => state.me?.customer?.customer_type?.type);
  if (!isInitialized || customerType !== 'company') return null;
  return (
    <Suspense fallback={null}>
      <CompanyResumes />
    </Suspense>
  );
}
